import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const AmericanExpressIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_148943)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="#016FD0"
        />
        <path
          d="M25.0357 18.2278H24.2456C24.0767 18.2278 23.9499 18.1211 23.9499 17.9568C23.9499 17.7969 24.0724 17.6903 24.2456 17.6903H25.6736L26.0073 16.9219H24.2414C23.5105 16.9219 23.0923 17.3749 23.0923 17.9834C23.0923 18.6186 23.4979 18.9917 24.1273 18.9917H24.9174C25.0906 18.9917 25.2089 19.0983 25.2089 19.2627C25.2089 19.427 25.0906 19.5336 24.9174 19.5336H23.1937V20.302H24.9174C25.6398 20.302 26.0665 19.8579 26.0665 19.2049C26.0707 18.592 25.6947 18.2278 25.0357 18.2278Z"
          fill="white"
        />
        <path
          d="M19.5688 18.0185C19.5688 17.37 19.1294 16.9258 18.4197 16.9258H16.5608V20.306H17.4184V19.12H17.731L18.7112 20.3015H19.7758L18.7112 19.08C19.2477 18.9646 19.5688 18.547 19.5688 18.0185ZM18.3183 18.3738H17.4184V17.6942H18.3183C18.576 17.6942 18.7027 17.8541 18.7027 18.0362C18.7069 18.2228 18.576 18.3738 18.3183 18.3738Z"
          fill="white"
        />
        <path
          d="M20.0166 20.306H22.7373V19.5375H20.8742V18.9957H22.6908V18.2272H20.8742V17.6942H22.7373V16.9258H20.0166V20.306Z"
          fill="white"
        />
        <path
          d="M15.0485 16.9258H13.1685V20.306H14.0261V19.2044H15.0231C15.7497 19.2044 16.1976 18.7202 16.1976 18.0673C16.1933 17.3877 15.754 16.9258 15.0485 16.9258ZM14.9471 18.436H14.0261V17.6942H14.9471C15.2048 17.6942 15.3315 17.863 15.3315 18.0718C15.3315 18.2716 15.2005 18.436 14.9471 18.436Z"
          fill="white"
        />
        <path
          d="M28.1958 18.2278H27.4058C27.2368 18.2278 27.1143 18.1211 27.1143 17.9568C27.1143 17.7969 27.2368 17.6903 27.4058 17.6903H28.8337L29.1675 16.9219H27.4016C26.6707 16.9219 26.2524 17.3749 26.2524 17.9834C26.2524 18.6186 26.658 18.9917 27.2875 18.9917H28.0775C28.2507 18.9917 28.3732 19.0983 28.3732 19.2627C28.3732 19.427 28.255 19.5336 28.0775 19.5336H26.3538V20.302H28.0817C28.8042 20.302 29.2309 19.8579 29.2309 19.2049C29.2266 18.592 28.8506 18.2278 28.1958 18.2278Z"
          fill="white"
        />
        <path
          d="M6.25684 20.3059H8.9733V19.5375H7.11444V18.9956H8.92684V18.2272H7.11444V17.6942H8.9733V16.9258H6.25684V20.3059Z"
          fill="white"
        />
        <path
          d="M13.0078 16.9258H11.9178L11.0813 17.943L10.2448 16.9258H9.12527L10.5406 18.5959L9.0957 20.306H10.1899L11.0644 19.231L11.9431 20.306H13.0627L11.6136 18.5781L13.0078 16.9258Z"
          fill="white"
        />
        <path d="M17.8325 15.3846H18.26H18.6918V13.6901V12H18.2643H17.8325V13.6901V15.3846Z" fill="white" />
        <path
          d="M17.3837 13.0941C17.3837 12.4448 16.9392 12 16.2323 12H14.3699V15.3846H15.2291V14.1971H15.5424L16.5202 15.3802H17.5869L16.5202 14.1571C17.062 14.0414 17.3837 13.6234 17.3837 13.0941ZM16.1308 13.4499H15.2291V12.7694H16.1308C16.3889 12.7694 16.5159 12.9295 16.5159 13.1119C16.5159 13.2987 16.3889 13.4499 16.1308 13.4499Z"
          fill="white"
        />
        <path
          d="M20.0082 13.7212V13.659C20.0082 13.1564 20.2749 12.7961 20.8252 12.7961H21.7818V12H20.7532C19.6907 12 19.1489 12.7161 19.1489 13.659V13.7257C19.1489 14.7753 19.7669 15.3846 20.7109 15.3846H21.0072L21.35 14.6152H20.8421C20.3299 14.6152 20.0082 14.3083 20.0082 13.7212Z"
          fill="white"
        />
        <path
          d="M3.57605 12L2.15381 15.3846H3.10199L3.37289 14.6997H4.86285L5.13799 15.3846H6.10735L4.68932 12H3.57605ZM3.66495 13.9525L4.11365 12.8228L4.56655 13.9525H3.66495Z"
          fill="white"
        />
        <path
          d="M8.35936 14.1304L7.62283 12H6.26831V15.3846H7.1149V12.9473L7.96573 15.3846H8.73188L9.58268 12.9473V15.3846H10.4293V12H9.09167L8.35936 14.1304Z"
          fill="white"
        />
        <path
          d="M11.0852 15.3846H13.807V14.6152H11.9445V14.0726H13.7604V13.3031H11.9445V12.7694H13.807V12H11.0852V15.3846Z"
          fill="white"
        />
        <path
          d="M22.8273 12L21.405 15.3846H22.3532L22.6241 14.6997H24.1141L24.3892 15.3846H25.3586L23.9405 12H22.8273ZM22.9204 13.9525L23.3691 12.8228L23.8178 13.9525H22.9204Z"
          fill="white"
        />
        <path
          d="M27.9195 14.0637L26.6073 12H25.5237V15.3846H26.3787V13.2409L27.729 15.3846H28.7703V12H27.9195V14.0637Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2177_148943">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
